import enGb from 'ant-design-vue/es/locale/en_GB'
const customEn = {
  login: {
    title: 'Welcome',
    rule: {
      name: 'please input your name',
      pwd: 'please input your password'
    }
  },
  button: {
    login: 'Login',
    import: 'import',
    export: 'export',
    create: 'create',
    delete: 'delete',
    renovate: 'renovate',
    searchCriteria: 'Search Criteria'
  }
}

const en = Object.assign(enGb, customEn)

export { en }
